import React, { useCallback, useMemo } from 'react';

import type { StripeCardElementChangeEvent } from '@stripe/stripe-js';

import { useI18n } from '@change-corgi/core/react/i18n';

import { DEFAULT_ERROR_VALIDATION, stripeErrorI18nKey, stripeInputName } from 'src/app/shared/utils/payments';

import { StyleWrapper } from '../../../../../components/StyleWrapper';
import { CardElementWrapper } from '../../../../components/StripeElementWrappers';
import type { SingleFormProps } from '../../types';

export function SingleForm(props: SingleFormProps): React.JSX.Element {
	const { translate } = useI18n();

	const { onCardDetailsFieldFocus, validationErrors, setValidationErrors } = props;

	const onChange = useCallback(
		(e: StripeCardElementChangeEvent) => {
			setValidationErrors?.({
				...DEFAULT_ERROR_VALIDATION,
				[stripeInputName(e.elementType) as string]: e.error ? stripeErrorI18nKey(e.error) : null,
			});
		},
		[setValidationErrors],
	);

	const error = useMemo(() => {
		if (validationErrors.card) {
			return validationErrors.card;
		}
		if (validationErrors.card_number) {
			return validationErrors.card_number;
		}
		if (validationErrors.card_expiration) {
			return validationErrors.card_expiration;
		}
		if (validationErrors.card_cvc) {
			return validationErrors.card_cvc;
		}
		return null;
	}, [validationErrors]);

	const labelText = translate('corgi.co.promote.card_details');

	return (
		<div data-qa="credit-card-details">
			<StyleWrapper
				label={labelText}
				errorMessage={error ? translate(error) : undefined}
				onFocus={onCardDetailsFieldFocus}
			>
				<CardElementWrapper onChange={onChange} />
			</StyleWrapper>
		</div>
	);
}
